//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';
import constant from '~/const';

export default {
  props: {
    value: { type: Boolean, default: false },
    data: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      input: {},
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),

    model: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    defaultInput() {
      return {
        id: 0,
        appName: '',
        active: false,
        claimList: [],
      };
    },

    getClaimsList() {
      return this.$utils.getAppType() === 'p2pay' ? constant.api.P2PAY_CLIENT_CLAIM_TYPE_LIST : constant.api.CLIENT_CLAIM_TYPE_LIST;
    },

    activeList() {
      return [
        {
          id: true,
          caption: 'Enabled',
        },
        {
          id: false,
          caption: 'Disabled',
        },
      ];
    },
  },

  watch: {
    value(val) {
      if (val) {
        const { defaultInput, data } = this;
        const model = { id: data.id };
        Object.keys(defaultInput).forEach((key) => {
          model[key] = data[key];
        });
        this.$set(this, 'input', model);
      }
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
    ]),

    async updateApiKey() {
      const { input } = this;
      this.$emit('update', { input });
    },
  },
};
